import { render, staticRenderFns } from "./allListStage1Region.vue?vue&type=template&id=03457f4c&scoped=true&"
import script from "./allListStage1Region.vue?vue&type=script&lang=js&"
export * from "./allListStage1Region.vue?vue&type=script&lang=js&"
import style0 from "./allListStage1Region.vue?vue&type=style&index=0&id=03457f4c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03457f4c",
  null
  
)

export default component.exports